import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Store, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fetchPincodeInfo } from "@/lib/api";

const KEY = "vb.sellVaranasiDismissed";

export default function SellInVaranasi() {
  const { pincode, user, isVendor } = useApp();
  const navigate = useNavigate();
  const [city, setCity] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY) === "1");

  useEffect(() => {
    setCity(null);
    if (!pincode) return undefined;
    let alive = true;
    fetchPincodeInfo(pincode).then((d) => alive && setCity(d?.city || null)).catch(() => {});
    return () => { alive = false; };
  }, [pincode]);

  if (dismissed || isVendor || (city || "").toLowerCase() !== "varanasi") return null;

  const become = () => {
    if (!user) { window.dispatchEvent(new Event("vb:open-auth")); return; }
    navigate("/profile?setup=1");
  };
  const dismiss = () => { sessionStorage.setItem(KEY, "1"); setDismissed(true); };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4" data-testid="sell-in-varanasi">
      <div className="relative flex flex-col sm:flex-row sm:items-center gap-3 bg-emerald-50 border border-emerald-100 rounded-2xl px-4 py-3 pe-10">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <div className="w-9 h-9 rounded-xl bg-emerald-700 text-white flex items-center justify-center flex-shrink-0"><Store className="w-4 h-4" /></div>
          <div className="min-w-0">
            <div className="font-display font-bold text-emerald-900">Sell in Varanasi</div>
            <div className="text-xs sm:text-sm text-emerald-800">Bring your shop online and reach more local customers.</div>
            <div className="text-[11px] sm:text-xs font-semibold text-amber-700 mt-0.5" data-testid="sell-varanasi-areas">Lanka • Sigra • Bhelupur • Assi • Godowlia and nearby areas</div>
          </div>
        </div>
        <button onClick={become} className="self-start sm:self-center flex-shrink-0 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white text-xs sm:text-sm font-semibold px-4 py-2 transition-colors" data-testid="sell-varanasi-cta">
          Become a Vendor
        </button>
        <button onClick={dismiss} className="absolute top-2 end-2 p-1 text-emerald-700 hover:text-emerald-900" aria-label="Dismiss" data-testid="sell-varanasi-dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
